<template>
  <div class="mb-4 dark-background">
    <div class="d-flex justify-content-between">
      <h6 class="ml-1 mb-0">{{ $t('message.testDrive.driveTipHeader') }}</h6>
      <div class="flip">
        <img :src="require('@/assets/fa/automobile.svg')" width="22" height="22" class="mr-1" alt="" />
        <img :src="require('@/assets/fa/dash-symbol.svg')" width="17" height="18" alt="" />
      </div>
    </div>
    <hr class="mx-1 my-2" />
    <p class="mx-0 p-small text-muted" v-if="$slots.description">
      <slot name="description"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'DriveTip',
};
</script>

<style scoped>
.flip {
  transform: scaleX(-1);
  margin-top: -5px;
  width: 75px;
}
.dark-background {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 16px 25px 2px 16px;
}
</style>
